import React, { useState } from 'react';
import { Buttons, Button, CancelButton, ModalCard } from '~/components';
import { useApi, useToast, useWorkspace } from '~/contexts';
import { useIsMounted } from '~/hooks';

export default function ReauthorizeConfirmation({ integration, onClose }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const toast = useToast();

  const [isLoading, setIsLoading] = useState(false);
  const isMounted = useIsMounted();

  async function handleReauthorize() {
    try {
      const { data } = await api.www.workspaces(workspace.id).bamboohr.authorize({ domain: integration.info.domain });

      if (data.authorizeUri) {
        window.location.href = data.authorizeUri;
      }
    } catch ({ message }) {
      if (message) {
        toast.error(message);
      } else {
        toast.error('There was a problem completing your request. Please try again later.');
      }
    } finally {
      if (isMounted.current) {
        setIsLoading(false);
      }
    }
  }

  return (
    <ModalCard title="Reauthorize Connection" onClose={onClose}>
      <ModalCard.Body>
        Reauthorizing the connection with BambooHR is only required if there is an issue with the connection.
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={onClose}>Cancel</CancelButton>
          <Button onClick={handleReauthorize} isLoading={isLoading}>
            Reauthorize
          </Button>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
